<template>
</template>

<script>
export default {
  name: 'BasePixel',
  props: {
    pixelType: {
      type: String,
      required: false,
      default: '',
    },
    target: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    async googlePixel() {
      if (!await this.hasScript()) {
        const pixel = document.createElement('script');
        pixel.setAttribute('type', 'application/javascript');
        pixel.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=AW-673514969');
        pixel.setAttribute('async', '');
        document.head.appendChild(pixel);
      }
      window.dataLayer = window.dataLayer || [];
      this.gtag('js', new Date());
      this.gtag('config', 'AW-673514969');
      this.trackEvent();
    },
    facebookPixel() {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '839835569863047');
      fbq('track', 'PageView');
      /* eslint-enable */
    },
    twitterPixel() {
      /* eslint-disable */
      !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
      // Insert Twitter Pixel ID and Standard Event data below
      twq('init','nzx95');
      twq('track','PageView');
      /* eslint-enable */
    },
    linkedInPixel() {
      /* eslint-disable */
      var _linkedin_partner_id = '30463';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);

      (function(){var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);})();
      /* eslint-enable */
    },
    appnexusPixel() {
      /* eslint-disable */
      !function(e,i){if(!e.pixie){var n=e.pixie=function(e,i,a){n.actionQueue.push({action:e,actionValue:i,params:a})};
      n.actionQueue=[];var a=i.createElement("script");a.async=!0,a.src="//acdn.adnxs.com/dmp/up/pixie.js";
      var t=i.getElementsByTagName("head")[0];t.insertBefore(a,t.firstChild)}}(window,document);
      pixie('init', '268834eb-dbea-4348-ae92-6871ba54eb0d');
      /* eslint-enable */
    },
    gtag() {
      // eslint-disable-next-line
      window.dataLayer.push(arguments);
    },
    trackEvent() {
      this.gtag('event', 'conversion', {
        send_to: this.target,
      });
    },
    hasScript() {
      const scripts = document.getElementsByTagName('script');
      if (scripts.length > 0) {
        for (let i = 0; i < scripts.length; i += 1) {
          const script = scripts[i];
          if (script.getAttribute('src') && script.getAttribute('src').includes('www.googletagmanager.com/gtag/js?id=AW-673514969')) {
            return true;
          }
        }
      }
      return false;
    },
  },
  mounted() {
    if (this.pixelType === 'google' && this.target) this.googlePixel();
    if (this.pixelType === 'facebook') this.facebookPixel();
    if (this.pixelType === 'twitter') this.twitterPixel();
    if (this.pixelType === 'linkedIn') this.linkedInPixel();
    if (this.pixelType === 'appnexus') this.appnexusPixel();
  },
};
</script>
